/* eslint-disable prefer-destructuring */
import { deepCopy } from '../../utils/assist';

export default {
    methods: {
        alignCls (column, row = {},type) {
            let cellClassName = '';
            if (row.cellClassName && column.key && row.cellClassName[column.key]) {
                cellClassName = row.cellClassName[column.key];
            }
            return [
                {
                    [`${cellClassName}`]: cellClassName, // cell className
                    [`${column.className}`]: column.className, // column className
                    [`${this.prefixCls}-column-${column.tdAlign &&type ? column.tdAlign : column.align}`]: column.tdAlign&&type ? column.tdAlign : column.align,
                    [`${this.prefixCls}-hidden`]: (this.fixed === 'left' && column.fixed !== 'left') || (this.fixed === 'right' && column.fixed !== 'right') || (!this.fixed && column.fixed && (column.fixed === 'left' || column.fixed === 'right'))
                }
            ];
        },
        isPopperShow (column) {
            return column.filters && ((!this.fixed && !column.fixed) || (this.fixed === 'left' && column.fixed === 'left') || (this.fixed === 'right' && column.fixed === 'right'));
        },
        setCellWidth (col,type) {
            let width = '';
            let column = deepCopy(col);
            if (column.width) {
                width = column.width;
                if (type && type === column.fixed && !column._original && column.width){
                    column.width = column.width;
                    width = column.width;
                }

            } else if (this.columnsWidth[column._index]) {
                if ( column.fixed){
                    width = this.columnsWidth[column._index].width;
                }

            }
            if (width === '0') {
             width = '';
            }
            if (column.fixed){
               // column.rowspan=4;
                if (!column._columnKey){
                    return `width:${width}px;height:${this.$parent.headerHeight}px;line-height:${this.$parent.headerHeight}px`;
                }
            }
            if(type === 'colspan'){
                return '';
            }

            return `width:${width}px`;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/table/mixin.js